import Lottie, { LottieRefCurrentProps } from "lottie-react";
import React, { useEffect, useRef } from "react";

interface Props {
  data: object;
}

function LottieIcon({ data }: Props) {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (lottieRef.current) {
        lottieRef.current.goToAndPlay(0, true);
      }
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  return (
    <Lottie
      lottieRef={lottieRef}
      autoPlay
      loop={false}
      renderer="svg"
      animationData={data}
    />
  );
}

export default LottieIcon;
